module.exports = __webpack_public_path__ + "media/country_flags/ps-e035a202.png";